import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

/** Response item for GET Cart/NotRecommendedItems */
export interface CartNotRecommendedItem {
  productId: number;
  supplierId: number;
  supplierCompanyId: number;
  itemNum: string;
  price: string;
  description: string;
  uom: string;
  itemsPerUom: number;
  casePack: string;
  manufacturerName: string;
  categoryId: number;
  catalogId: number;
  quantityOrdered: number;
  clientOrderBinId: number;
  accountingCode: string;
  weight: string;
  isCompanySpecifiedItem: boolean;
  isRebateItem: boolean;
  priceGroupId: number;
}

export type CartNotRecommendedItemsResponse = CartNotRecommendedItem[];

async function fetchCartNotRecommendedItems(): Promise<CartNotRecommendedItemsResponse> {
  const response = await axiosInstance.get<CartNotRecommendedItemsResponse>(
    api.getCartNotRecommendedItems
  );
  return response.data;
}

export interface UseGetCartNotRecommendedItemsQueryOptions {
  enabled?: boolean;
}

const useGetCartNotRecommendedItemsQuery = (
  options: UseGetCartNotRecommendedItemsQueryOptions = {}
) => {
  const { enabled = true } = options;
  return useQuery<CartNotRecommendedItemsResponse>({
    queryKey: queryKeys.cart.notRecommendedItems(),
    queryFn: fetchCartNotRecommendedItems,
    enabled,
  });
};

export default useGetCartNotRecommendedItemsQuery;
